import React from "react";
import { X, AlertTriangle, Trash2, Check } from "lucide-react";
import { useApp } from "../../context/AppContext";
import { FONT_SIZES, FONT_FAMILY, ICON_SIZES } from "../../constants/appConfig";
import { Card } from "./Card";
import { ActionButton } from "./ActionButton";

export const Modal = ({ title, icon: ModalIcon, onClose, width = 550, children }) => {
  const { palette } = useApp();
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: FONT_FAMILY }}
      onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{
        background: palette.cardBg, borderRadius: 16,
        width: `min(${width}px, 92vw)`, maxHeight: "85vh", overflow: "auto",
        boxShadow: "0 20px 60px rgba(0,0,0,0.2)", border: `1px solid ${palette.cardBorder}`
      }}>
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px",
          borderBottom: `1px solid ${palette.cardBorder}`, position: "sticky", top: 0, background: palette.cardBg, zIndex: 1
        }}>
          <h2 style={{ margin: 0, fontSize: FONT_SIZES.lg, color: palette.text1, fontFamily: FONT_FAMILY, display: "flex", alignItems: "center", gap: 8 }}>
            {ModalIcon && <ModalIcon size={ICON_SIZES.md} style={{ color: palette.accent1 }} />}{title}
          </h2>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: palette.text3, padding: 4 }}>
            <X size={ICON_SIZES.md} />
          </button>
        </div>
        <div style={{ padding: 24 }}>{children}</div>
      </div>
    </div>
  );
};

export const ConfirmDialog = ({ title, message, onConfirm, onCancel, confirmLabel = "Confirm", variant = "danger" }) => {
  const { palette } = useApp();
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1001 }}
      onClick={onCancel}>
      <Card onClick={e => e.stopPropagation()} style={{ width: "min(420px, 90vw)", padding: 28, textAlign: "center" }}>
        <AlertTriangle size={ICON_SIZES.xxl} style={{ color: variant === "danger" ? "#ef4444" : palette.accent1, marginBottom: 12 }} />
        <h3 style={{ margin: "0 0 8px", color: palette.text1, fontFamily: FONT_FAMILY }}>{title}</h3>
        <p style={{ color: palette.text2, fontSize: FONT_SIZES.sm, marginBottom: 20 }}>{message}</p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
          <ActionButton label="Cancel" variant="secondary" onClick={onCancel} />
          <ActionButton label={confirmLabel} variant={variant} icon={variant === "danger" ? Trash2 : Check} onClick={onConfirm} />
        </div>
      </Card>
    </div>
  );
};
